import { ChartOptions, TooltipItem } from "chart.js"

export const createDashboardBarStringsChartOptions = ({
  isStacked,
  showAsPercentage,
  shouldShowLabels,
  showLegend,
  legendPosition,
  timestepLabels,
  onLegendClick,
}: {
  isStacked: boolean
  showAsPercentage: boolean
  shouldShowLabels: boolean
  showLegend: boolean | undefined
  legendPosition: "top" | "bottom"
  timestepLabels: number[]
  onLegendClick?: (datasetLabel: string) => void
}): ChartOptions<"bar"> => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: showLegend ?? true,
      position: legendPosition,
      onClick: (_event, legendItem) => {
        const datasetLabel = legendItem.text
        if (!datasetLabel) {
          return
        }

        onLegendClick?.(datasetLabel)
      },
      labels: {
        filter: (item: { text: string }) => Boolean(item.text),
      },
    },
    tooltip: {
      mode: "index",
      position: "average",
      callbacks: {
        label: (tooltipItem: TooltipItem<"bar">) => [
          tooltipItem.dataset.label || "",
          showAsPercentage
            ? `${Number(tooltipItem.raw || 0).toFixed(2)}%`
            : `${Math.round(Number(tooltipItem.raw || 0))}`,
        ],
      },
    },
    datalabels: {
      display: shouldShowLabels,
      formatter: (value: number) => {
        if (!value) {
          return ""
        }

        return showAsPercentage ? `${Math.round(value)}%` : `${Math.round(value)}`
      },
      color: "#fff",
      anchor: "center",
      align: "center",
    },
    zoom: {
      limits: {
        x: { minRange: 2 },
      },
      zoom: {
        drag: {
          enabled: true,
        },
        pinch: {
          enabled: true,
        },
        mode: "x",
      },
    },
  },
  scales: {
    x: {
      stacked: isStacked,
      min: timestepLabels[0] || undefined,
      max: timestepLabels[timestepLabels.length - 1] || undefined,
      ticks: {
        callback: (_value, index) => {
          const timestep = timestepLabels[index]
          if (timestep === undefined) {
            return ""
          }

          return String(timestep)
        },
      },
    },
    y: {
      stacked: isStacked,
      min: 0,
      max: showAsPercentage ? 100 : undefined,
      ticks: {
        callback: (value) => (showAsPercentage ? `${value}%` : `${value}`),
      },
    },
  },
})
